<template>
  <div>
    <div class="user-info-list">
      <el-table
        :data="dataList"
        stripe
        highlight-current-row
        border
        style="width: 100%"
        v-loading="loading"
      >
        <template v-for="attr of columns">
          <el-table-column v-if="attr.prop === 'sj_user_workinfo_audit_id'"
                           v-bind="attr">
            <template slot-scope="scope">
              <el-link type="text"
                       :href="`/user-workinfo/detail/${scope.row.sj_user_workinfo_audit_id}`"
                       target="_blank">
                {{ scope.row.sj_user_workinfo_audit_id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column v-else-if="attr.prop === 'business_type_json'"
                           v-bind="attr">
            <template slot-scope="scope">
              <span>{{ getBusinessType(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-else
                           v-bind="attr"></el-table-column>
        </template>

        <el-table-column prop="workcard_photo"
                         label="工作证明"
                         width="500"
                         class-name="workcard-photo-cell"
                         key="workcard_photo">
          <template slot-scope="scope">
            <div :id="`photoContainer${scope.$index}`"
                 class="photo-list">
              <template v-for="(url, index) in scope.row.content.workcard_photo">
                <!-- 视频类型 -->
                <video v-if="isVideoFile(url)"
                       :key="'video-' + index"
                       :src="url"
                       class="avatar video-preview"
                       style="width:80px;height:80px;flex-shrink:0;cursor: pointer"
                       preload="metadata"
                       @click="openVideoDialog(url, index, scope.row)">
                </video>
                <!-- 图片类型 -->
                <img v-else-if="isImageFile(url)"
                     :key="'img-' + index"
                     :src="url | ossFormatJpg"
                     @click="onViewPhotos(index,scope.$index)"
                     class="avatar"
                     style="width:80px;height:80px;cursor: zoom-in"
                     alt="">
                <!-- 未知类型 -->
                <div v-else
                     :key="'unknown-' + index"
                     class="avatar unknown-file"
                     style="width:80px;height:80px;display:flex;flex-direction:column;align-items:center;justify-content:center;background-color:#f5f7fa;font-size:12px;color:#909399"
                     :title="url">
                  <i class="el-icon-document"
                     style="font-size:24px;margin-bottom:2px;color:#dcdfe6"></i>
                  <span style="line-height:1.2;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%">未知类型的文件</span>
                </div>
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>


      <!-- 分页组件 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        />
      </div>
    </div>

    <!-- 视频播放弹窗 -->
    <video-player-dialog
      :visible.sync="videoDialogVisible"
      :videos="videoDialogVideos"
      :index="videoDialogIndex" />
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import userWorkInfoMixin from '@views/user-workinfo/user-workinfo.mixin.js'
import Viewer from 'viewerjs'
import VideoPlayerDialog from '@views/user-workinfo/components/VideoPlayerDialog.vue'

export default {
  mixins: [userWorkInfoMixin],
  name: 'WorkInfoHistory',
  components: {VideoPlayerDialog},
  props: {
    userId: {
      type: [String, Number],
      required: true
    },
  },
  data () {
    return {
      dataList: [],
      loading: false,
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      columns: [
        {prop: 'id', label: '快照ID'},
        {prop: 'sj_user_workinfo_audit_id', label: '审核数据ID'},
        {prop: 'created_at', label: '提交时间', width: 180},
        {prop: 'updated_by', label: '提交人'},
        {prop: 'business_type_json', label: '行业'},
        {prop: 'work_type_cn', label: '工种'},
        {prop: 'content.belongto', label: '公司名称'},
      ],
      videoDialogVisible: false,
      videoDialogVideos: [],
      videoDialogIndex: 0,
    }
  },
  watch: {
    userId: {
      immediate: true,
      handler () {
        this.getData()
      }
    }
  },
  async created () {
    await this.$store.dispatch('getUserRelatedOptions')
  },
  computed: {
    ...Vuex.mapState({
      userOptions: state => state.users.userOptions,
    })
  },
  methods: {
    async getData () {
      this.loading = true
      try {
        const {data} = await request.common('queryWorkInfoSnapshotApi', {
          userid: this.userId,
          current_page: this.pagination.current,
          per_page: this.pagination.size
        })
        this.dataList = data.data
        this.pagination.total = data.total
      } finally {
        this.loading = false
      }
    },
    handleSizeChange (size) {
      this.pagination.size = size
      this.getData()
    },
    handleCurrentChange (current) {
      this.pagination.current = current
      this.getData()
    },
    onViewPhotos (index, i) {
      if (this.viewer) {
        this.viewer.destroy()
      }
      this.viewer = new Viewer(document.getElementById(`photoContainer${i}`))
      this.viewer.view(index)
    },
    getBusinessType (row) {
      const businessTypeId = _.get(row, 'content.business_type')
      const businessTypeObj = this.userOptions.business_type.find(it => it.id + '' === businessTypeId + '')
      return _.get(businessTypeObj, 'title', '-')
    },
    /**
     * 打开视频播放弹窗（委托给独立组件 VideoPlayerDialog）
     * @param {string} url - 视频URL
     * @param {number} index - 在 workcard_photo 中的索引（保留以兼容调用处）
     * @param {object} row - 当前行数据
     */
    openVideoDialog (url, index, row) {
      const videoList = (row.content.workcard_photo || []).filter(photo => this.isVideoFile(photo))
      this.videoDialogVideos = videoList
      this.videoDialogIndex = Math.max(videoList.indexOf(url), 0)
      this.videoDialogVisible = true
    },
  }
}
</script>

<style scoped
       lang="scss">
.user-info-list {
  .image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }

  .pagination-wrapper {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
}

.workcard-photo-cell {
  .cell {
    overflow: visible;
  }
}

.photo-list {
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  overflow-x: auto;
  overflow-y: hidden;
}

// 视频预览样式 - 提示可以点击
.video-preview {
  position: relative;
  cursor: pointer !important;
  background-color: #000;
}
</style>



// WEBPACK FOOTER //
// src/views/user-workinfo/components/work-info-history/WorkInfoHistory.vue